import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.app-text-strong { color: ${dt('appText.strong.color')}; }
.app-text-emphasis { color: ${dt('appText.emphasis.color')}; }
.app-text-body { color: ${dt('appText.body.color')}; }
.app-text-secondary { color: ${dt('appText.secondary.color')}; }
.app-text-label { color: ${dt('appText.label.color')}; }
.app-text-subdued { color: ${dt('appText.subdued.color')}; }
.app-text-meta { color: ${dt('appText.meta.color')}; }
.app-text-muted { color: ${dt('appText.muted.color')}; }
.app-text-faint { color: ${dt('appText.faint.color')}; }
.app-text-default { color: ${dt('appText.default.color')}; }
.app-text-field-label { color: ${dt('appText.fieldLabel.color')}; }
.app-text-ink { color: ${dt('appText.ink.color')}; }
.app-text-contrast { color: ${dt('appText.contrast.color')}; }
.app-text-primary { color: ${dt('appText.primary.color')}; }
.app-text-primary-soft { color: ${dt('appText.primarySoft.color')}; }
.app-text-primary-strong { color: ${dt('appText.primaryStrong.color')}; }
.app-text-error { color: ${dt('appText.error.color')}; }
.app-text-danger { color: ${dt('appText.danger.color')}; }
.app-text-danger-soft { color: ${dt('appText.dangerSoft.color')}; }
.app-text-success { color: ${dt('appText.success.color')}; }
`;
